import { A } from "@solidjs/router";
import { For, type JSX, Show } from "solid-js";
import { CatAvatar } from "@/components/CatAvatar";
import { Badge } from "@/components/ui";
import { isAdmin, me } from "@/state/me";
import { connected, online } from "@/state/realtime";

export function OnlineUsers(): JSX.Element {
  const others = () => online().filter((user) => user.id !== me()?.id);

  return (
    <div class="online">
      <div class="online-head">
        <span class="part-legend">オンライン</span>
        <Badge variant={connected() ? "success" : "neutral"}>{online().length}</Badge>
      </div>
      <Show
        when={others().length > 0}
        fallback={<p class="online-empty">ほかに接続中の人はいません</p>}
      >
        <ul class="online-list">
          <For each={others()}>
            {(user) => (
              <li>
                {/* メッセージはプロフィールから送る。オンラインかどうかで導線を分けない */}
                <A
                  href={`/u/${user.handle}`}
                  class="online-user"
                  title={`${user.name} のプロフィール`}
                >
                  <CatAvatar avatar={user.avatar} size={24} label={`${user.name} のアバター`} />
                  <span>{user.name}</span>
                  <Show when={user.isBot && isAdmin()}>
                    <Badge variant="info" size="sm">
                      bot
                    </Badge>
                  </Show>
                </A>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </div>
  );
}
